<h1 mat-dialog-title>Anmelden als anderen Benutzer</h1>
<form [formGroup]="AuthentifikationForm">
    <mat-dialog-content>
        <h5>Anmelden als anderer Benutzer: {{ data.user.vorname }} {{ data.user.nachname }}</h5>
        <div *ngIf="!twoFaGenerated">
            <button mat-flat-button color="primary" (click)="onGenerate2Fa()" [disabled]="generating"
                >2FA Generieren</button
            >
        </div>
        <div *ngIf="twoFaGenerated">
            <p>2FA Schlüssel wurde versendet.</p>
            <mat-form-field style="width: 100%">
                <mat-label>2FA Authentifizierung</mat-label>
                <input placeholder="2FA Schlüssel" matInput formControlName="AuthentKey" />
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button (click)="closeDialog()"> Abbrechen </button>
        <button
            mat-flat-button
            (click)="safeAndCloseDialog()"
            color="accent"
            type="submit"
            [disabled]="!twoFaGenerated"
        >
            Anmelden
        </button>
    </mat-dialog-actions>
</form>
